// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Wu6Nm","controls":"styles_controls__1Pyyv","charLimit":"styles_charLimit__1KyS2","input":"styles_input__SNIkF","send":"styles_send__3WVwb"};